/* import __COLOCATED_TEMPLATE__ from './welcome-screen.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { findLatestVBP2PlanData, findLatestPricing5PlanData } from 'embercom/lib/billing';
import type CardlessTrialService from 'embercom/services/cardless-trial-service';
import type CompellingOfferCampaignService from 'embercom/services/compelling-offer-campaign-service';
import type IntlService from 'embercom/services/intl';
import { assetUrl } from '@intercom/pulse/helpers/asset-url';

interface Args {
  onButtonClick: () => void;
  firstName: string;
  platform: string;
}

interface Signature {
  Element: any;
  Args: Args;
}

export default class WelcomeScreen extends Component<Signature> {
  @service declare cardlessTrialService: CardlessTrialService;
  @service declare compellingOfferCampaignService: CompellingOfferCampaignService;
  @service declare intl: IntlService;
  @service appService: any;

  get hasCampaignWelcomeScreen(): boolean {
    return this.compellingOfferCampaignService.hasWelcomeScreen();
  }

  get campaignHeading(): string {
    return this.compellingOfferCampaignService.welcomeScreenHeading;
  }

  get campaignDescription(): string {
    return this.compellingOfferCampaignService.welcomeScreenDescription(this.trialPlanName);
  }

  get profilingSurveyWelcomeScreenImage() {
    if (this.appService.app.canUseStandalone) {
      if (this.args.platform === 'Zendesk') {
        return assetUrl(
          '/assets/images/onboarding/guide-library/fin-sa-zendesk-profiling-survey-welcome-screen.png',
        );
      }
    }
    return assetUrl('/assets/images/onboarding/guide-library/profiling-survey-welcome-screen.png');
  }

  get workspaceIsInTrial() {
    return this.cardlessTrialService.hasActiveTrialSubscriptionOrInTrialOrExpiredTrial;
  }

  get finSADescription() {
    if (this.args.platform === 'Zendesk') {
      return this.intl.t(
        'onboarding.guide-library.profiling-survey.welcome-screen.description-sa.zendesk',
        {
          workspaceIsInTrial: this.workspaceIsInTrial,
        },
      );
    }
    return '';
  }

  get trialPlanName() {
    let trialPlanData;
    let trialPlanIds = this.cardlessTrialService.activeOrExpiredPlanTrialIds;

    if (this.cardlessTrialService.isPricing5) {
      trialPlanData = findLatestPricing5PlanData(trialPlanIds);
    } else {
      trialPlanData = findLatestVBP2PlanData(trialPlanIds);
    }

    return this.intl.t(trialPlanData.nameTranslationKey);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Onboarding::GuideLibrary::ProfilingSurvey::WelcomeScreen': typeof WelcomeScreen;
  }
}
